import { localizedProviderTitleId } from '../../modules/core';

export const USER_TITLE_OTHER = 'Other';

export default angular
  .module('doxy.global.models.user', [])
  .service('UserMethods', function ($translate) {
    return {
      isNull() {
        return !Boolean(this.id);
      },

      getDisplayName() {
        if (this.isNull()) {
          return;
        }
        if (Boolean(this.displayName)) {
          // eslint-disable-next-line consistent-return
          return this.displayName;
        }

        const hasTitle = Boolean(this.title) && this.title !== USER_TITLE_OTHER;
        // eslint-disable-next-line consistent-return
        return hasTitle
          ? `${$translate.instant(localizedProviderTitleId(this.title))} ${
              this.lastName
            }`
          : `${this.lastName}`;
      },

      hasDayPass() {
        if (!this.dayPassEndDate) return false;
        return new Date(this.dayPassEndDate).getTime() > new Date().getTime();
      },

      isUpgraded() {
        return (
          this.institutionMember ||
          this.activePurchase ||
          this.trialEndDate ||
          this.hasDayPass()
        );
      },

      hasSuperAdminRights() {
        return (
          this.capabilities &&
          this.capabilities.some((item) => item.capability === 'master_access')
        );
      },
    };
  }).name;
